import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAuthError } from "../../redux/slice/authSlice";
import { initiateAuth } from "../../redux/auth";
import TextInput from "../../components/formInputs/TextInput";
import Button from "../../components/buttons/Button";
import MangoLogo from "../../components/icons/MangoLogo";
import UserIcon from "../../components/icons/UserIcon";
import EmailIcon from "../../components/icons/EmailIcon";
import "../../components/styles/registerPage.scss";

/**
 * RegisterPage — MangoTV "Create Account" screen (onboarding)
 * Fields: Full Name, Email (passwordless — OTP verification)
 */
const RegisterPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, error } = useSelector((state) => state.auth);

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");

  const isFormValid =
    fullName.trim() !== "" &&
    email.trim() !== "";

  const handleRegister = useCallback(async () => {
    if (!isFormValid || isLoading) return;
    dispatch(setAuthError(null));

    await initiateAuth(email.trim(), navigate);
  }, [isFormValid, isLoading, dispatch, navigate, email]);

  return (
    <div className="register-page">
      {/* LEFT: Onboarding Sidebar */}
      <div className="register-page__image-container">
        <img
          src="/assets/onboarding-sidebar-bg.jpg"
          alt=""
          className="register-page__sidebar-bg"
        />
      </div>

      {/* RIGHT: Form Container */}
      <div className="register-page__container">
        <div className="register-page__bg-pattern">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <circle cx="215" cy="493" r="2" fill="#404040" opacity="0.5" />
            <circle cx="328" cy="129" r="2" fill="#404040" opacity="0.5" />
            <circle cx="492" cy="975" r="2" fill="#404040" opacity="0.5" />
            <circle cx="772" cy="207" r="2" fill="#404040" opacity="0.5" />
            <circle cx="593" cy="66" r="2" fill="#404040" opacity="0.5" />
          </svg>
        </div>

        <div className="register-page__wrapper">
          <div className="register-page__content">
            {/* Title */}
            <div className="register-page__title-section">
              <MangoLogo size={80} />
              <h1 className="register-page__title">Create Account</h1>
              <p className="register-page__subtitle">
                Join OpenPlay and start streaming today
              </p>
            </div>

            {/* Form */}
            <div className="register-page__form-group">
              <div className="register-page__form">
                <TextInput
                  label="Full Name"
                  value={fullName}
                  onChange={setFullName}
                  placeholder="eg. Dean Lewis"
                  type="text"
                  leftIcon={<UserIcon />}
                />

                <TextInput
                  label="Email Address"
                  value={email}
                  onChange={setEmail}
                  placeholder="eg. yami@yahoo.com"
                  type="email"
                  leftIcon={<EmailIcon />}
                />
              </div>

              {error && (
                <p style={{ color: "#ef4444", fontSize: "14px", textAlign: "center" }}>
                  {error}
                </p>
              )}

              <Button
                label="Register"
                size="lg"
                variant="primary"
                isDisabled={!isFormValid}
                isLoading={isLoading}
                action={handleRegister}
              />
            </div>
          </div>

          <p className="register-page__bottom-link">
            Already have an account? <span onClick={() => navigate("/")}>Login</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
